import React from "react";
import Nav from "../master/NavBar";
import Header from "../master/SideBar";
import { Link, useLocation } from "react-router-dom";
import { formatDate } from "../master/Master";

const TestResultsTable = () => {
  const location = useLocation();
  // const studentId = location?.state?.id
  const queryParams = new URLSearchParams(location.search);

  const studentId = queryParams.get("id");
  const testData = [
    {
      test: "YEARLY LKG. A(103)",
      date: "2025-03-05",
      subjects: {
        hindi: "No Marks Uploaded",
        english: "No Marks Uploaded",
        maths: "No Marks Uploaded",
      },
      studentRank: 0,
      obtainMarks: 0,
      totalMarks: 300,
      percentage: "0.00 %",
    },
    {
      test: "HALF YEARLY LKG. I(102)",
      date: "2025-03-01",
      subjects: {
        hindi: "No Marks Uploaded",
        english: "No Marks Uploaded",
        maths: "No Marks Uploaded",
      },
      studentRank: 0,
      obtainMarks: 0,
      totalMarks: 300,
      percentage: "0.00 %",
    },
  ];

  return (
    <>
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />
          <div className="layout-page">
            <Nav />
            <div className="content-wrapper container-fluid  flex-grow-1 "></div>
            <div className="container-xxl">
              <div className="card mb-4 p-5">
                <div className="d-flex gap-3 justify-content-end"></div>

                <div className="d-flex flex-wrap gap-3 ">
                  <Link
                    to={`/student/details?id=${studentId}`}
                    className="btn btn-sm btn-label-primary"
                  >
                    Student Profile
                  </Link>

                  <Link
                    to={`/student/course_fee?id=${studentId}`}
                    className="btn btn-sm btn-label-primary"
                  >
                    Course & Fee
                  </Link>
                  <Link
                    to={`/student/hostel?id=${studentId}`}
                    className="btn btn-sm btn-label-primary"
                  >
                    Student Hostel
                  </Link>

                  <Link
                    to={`/student/marks_report?id=${studentId}`}
                    className="btn btn-sm btn-primary"
                  >
                    Marks Report
                  </Link>
                  <Link
                    to={`/student/kit_report?id=${studentId}`}
                    className="btn btn-sm btn-label-primary"
                  >
                    Kit Report
                  </Link>
                  <Link
                    to={`/students`}
                    className="btn btn-sm btn-outline-primary ms-auto"
                  >
                    <i className="bi bi-arrow-left-circle me-1"></i> Back
                  </Link>
                </div>
              </div>
              <div className="container-fluid mt-4 border p-4 rounded bg-white shadow-sm">
                <h3 className="text-primary fw-semibold mb-4">
                  <strong>Course:</strong> LKG.(5)
                </h3>
                <p className="mb-1">
                  <strong>Batch:</strong> A(63)
                </p>
                <hr />
                <p className="mb-2">
                  <strong>Test Series:</strong> LKG TEST
                </p>

                <div className="text-end mb-2 fw-semibold">
                  | Obtain Marks : 0 | Total Marks : 600 | Avg. : 0.00 % |
                </div>

                <div className="table-responsive">
                  <table className="table table-bordered">
                    <thead className="text-white bg-primary text-center">
                      <tr>
                        <th>Test</th>
                        <th>Date</th>
                        <th>HINDI</th>
                        <th>ENGLISH</th>
                        <th>MATHS</th>
                        <th>Student Rank</th>
                        <th>Obtain Marks</th>
                        <th>Total Marks</th>
                        <th>Percentage</th>
                      </tr>
                    </thead>
                    <tbody className="text-center align-middle">
                      {testData.map((item, index) => (
                        <tr key={index}>
                          <td>{item.test}</td>
                          <td>{formatDate(item.date)}</td>
                          <td className="text-warning fw-semibold">
                            {item.subjects.hindi}
                          </td>
                          <td className="text-warning fw-semibold">
                            {item.subjects.english}
                          </td>
                          <td className="text-warning fw-semibold">
                            {item.subjects.maths}
                          </td>
                          <td>{item.studentRank}</td>
                          <td>{item.obtainMarks}</td>
                          <td>{item.totalMarks}</td>
                          <td>{item.percentage}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="container-fluid mt-4 border p-4 rounded bg-white shadow-sm">
                <h3 className="text-primary fw-semibold mb-4">
                  <strong>Course:</strong> LKG.(5)
                </h3>
                <p className="mb-1">
                  <strong>Batch:</strong> A(63)
                </p>
                <hr />
                <p className="mb-2">
                  <strong>Test Series:</strong> LKG TEST
                </p>

                <div className="text-end mb-2 fw-semibold">
                  | Obtain Marks : 0 | Total Marks : 600 | Avg. : 0.00 % |
                </div>

                <div className="table-responsive">
                  <table className="table table-bordered">
                    <thead className="text-white bg-primary text-center">
                      <tr>
                        <th>Test</th>
                        <th>Date</th>
                        <th>HINDI</th>
                        <th>ENGLISH</th>
                        <th>MATHS</th>
                        <th>Student Rank</th>
                        <th>Obtain Marks</th>
                        <th>Total Marks</th>
                        <th>Percentage</th>
                      </tr>
                    </thead>
                    <tbody className="text-center align-middle">
                      {testData.map((item, index) => (
                        <tr key={index}>
                          <td>{item.test}</td>
                          <td>{formatDate(item.date)}</td>
                          <td className="text-warning fw-semibold">
                            {item.subjects.hindi}
                          </td>
                          <td className="text-warning fw-semibold">
                            {item.subjects.english}
                          </td>
                          <td className="text-warning fw-semibold">
                            {item.subjects.maths}
                          </td>
                          <td>{item.studentRank}</td>
                          <td>{item.obtainMarks}</td>
                          <td>{item.totalMarks}</td>
                          <td>{item.percentage}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="container-fluid mt-4 mb-5 border p-4 rounded bg-white shadow-sm">
                <h3 className="text-primary fw-semibold mb-4">
                  <strong>Course:</strong> LKG.(5)
                </h3>
                <p className="mb-1">
                  <strong>Batch:</strong> A(63)
                </p>
                <hr />
                <p className="mb-2">
                  <strong>Test Series:</strong> LKG TEST
                </p>

                <div className="text-end mb-2 fw-semibold">
                  | Obtain Marks : 0 | Total Marks : 600 | Avg. : 0.00 % |
                </div>

                <div className="table-responsive">
                  <table className="table table-bordered">
                    <thead className="text-white bg-primary text-center">
                      <tr>
                        <th>Test</th>
                        <th>Date</th>
                        <th>HINDI</th>
                        <th>ENGLISH</th>
                        <th>MATHS</th>
                        <th>Student Rank</th>
                        <th>Obtain Marks</th>
                        <th>Total Marks</th>
                        <th>Percentage</th>
                      </tr>
                    </thead>
                    <tbody className="text-center align-middle">
                      {testData.map((item, index) => (
                        <tr key={index}>
                          <td>{item.test}</td>
                          <td>{formatDate(item.date)}</td>
                          <td className="text-warning fw-semibold">
                            {item.subjects.hindi}
                          </td>
                          <td className="text-warning fw-semibold">
                            {item.subjects.english}
                          </td>
                          <td className="text-warning fw-semibold">
                            {item.subjects.maths}
                          </td>
                          <td>{item.studentRank}</td>
                          <td>{item.obtainMarks}</td>
                          <td>{item.totalMarks}</td>
                          <td>{item.percentage}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TestResultsTable;
